import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const RqaPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#FFF0F6',
      100: '#FFE0ED',
      200: '#FAB8D9',
      300: '#F191C0',
      400: '#E85BA6',
      500: '#C4007A',
      600: '#A00065',
      700: '#7C004F',
      750: '#660040',
      800: '#520034',
      900: '#3D0026',
      950: '#280018'
    },
    colorScheme: {
      light: {
        primary: {
          color: '#C4007A',
          inverseColor: '#ffffff',
          hoverColor: '#A80079',
          activeColor: '#A80079'
        },
        highlight: {
          background: '#C4007A',
          focusBackground: '#A80079',
          color: '#ffffff',
          focusColor: '#ffffff'
        }
      },
      dark: {
        primary: {
          color: '#C4007A',
          inverseColor: '#ffffff',
          hoverColor: '#A80079',
          activeColor: '#A80079'
        },
        highlight: {
          background: '#C4007A',
          focusBackground: '#A80079',
          color: '#ffffff',
          focusColor: '#ffffff'
        }
      }
    }
  },
  extend: {
    typography: {
      fontSize: '0.875rem'
    }
  },
  css: ({ dt }: { dt: (token: string) => string }) => `
    /* Global font-size for all PrimeNG components */
    .p-component {
      font-size: ${dt('typography.fontSize')};
    }
  `,
  components: {
    button: {
      borderRadius: '0px',
      roundedBorderRadius: '50%'
    },
    inputtext: {
      borderRadius: '0px'
    },
    dropdown: {
      borderRadius: '0px'
    },
    multiselect: {
      borderRadius: '0px'
    },
    calendar: {
      borderRadius: '0px'
    },
    inputnumber: {
      borderRadius: '0px'
    },
    inputmask: {
      borderRadius: '0px'
    },
    textarea: {
      borderRadius: '0px'
    },
    password: {
      borderRadius: '0px'
    },
    autocomplete: {
      borderRadius: '0px'
    },
    chips: {
      borderRadius: '0px'
    },
    listbox: {
      borderRadius: '0px'
    },
    treeselect: {
      borderRadius: '0px'
    },
    checkbox: {
      borderRadius: '0px'
    },
    togglebutton: {
      borderRadius: '0px'
    },
    selectbutton: {
      borderRadius: '0px'
    },
    select: {
      borderRadius: '0px'
    },
    panel: {
      borderRadius: '0px'
    },
    dialog: {
      borderRadius: '0px'
    },
    overlaypanel: {
      borderRadius: '0px'
    },
    tooltip: {
      borderRadius: '0px'
    },
    menu: {
      borderRadius: '0px'
    },
    contextmenu: {
      borderRadius: '0px'
    },
    menubar: {
      borderRadius: '0px'
    },
    tieredmenu: {
      borderRadius: '0px'
    },
    datatable: {
      borderRadius: '0px'
    },
    paginator: {
      borderRadius: '0px'
    },
    card: {
      borderRadius: '0px'
    },
    fieldset: {
      borderRadius: '0px'
    },
    tabview: {
      borderRadius: '0px'
    },
    accordion: {
      borderRadius: '0px'
    },
    toast: {
      borderRadius: '0px'
    },
    message: {
      borderRadius: '0px'
    },
    inlinemessage: {
      borderRadius: '0px'
    },
    progressbar: {
      borderRadius: '0px'
    }
  }
});
